/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkUpdateLeadSOffenderRecordsRequest
 */
export interface BulkUpdateLeadSOffenderRecordsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateLeadSOffenderRecordsRequest
     */
    ids: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateLeadSOffenderRecordsRequest
     */
    is_dismissed: boolean;
}

/**
 * Check if a given object implements the BulkUpdateLeadSOffenderRecordsRequest interface.
 */
export function instanceOfBulkUpdateLeadSOffenderRecordsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ids" in value;
    isInstance = isInstance && "is_dismissed" in value;

    return isInstance;
}

export function BulkUpdateLeadSOffenderRecordsRequestFromJSON(json: any): BulkUpdateLeadSOffenderRecordsRequest {
    return BulkUpdateLeadSOffenderRecordsRequestFromJSONTyped(json, false);
}

export function BulkUpdateLeadSOffenderRecordsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateLeadSOffenderRecordsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ids': json['ids'],
        'is_dismissed': json['is_dismissed'],
    };
}

export function BulkUpdateLeadSOffenderRecordsRequestToJSON(value?: BulkUpdateLeadSOffenderRecordsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ids': value.ids,
        'is_dismissed': value.is_dismissed,
    };
}

